module.exports = __webpack_public_path__ + "img/empty-permission.png?f43a9aaa";